<ml-status-message-popup-v2
  [popupInfo]="statusPopupElement"
  (closeEvent)="closeStatusMessagePopup()"
></ml-status-message-popup-v2>
@if (isUserConnected()) {
  <div class="container">
    <ml-select-signal
      [formField]="translationForm.choice"
      id="field1"
      [mapValues]="translations"
      [label]="'application.translation' | translate"
    ></ml-select-signal>
  </div>

  @if (isLoadingPreferences()) {
    <ml-loader></ml-loader>
  } @else {
    <ml-card-container [title]="'application.parameters.notification.title' | translate" [icon]="'phone'">
      <ml-yes-no-signal-input
        class="select"
        [formField]="notificationForm.isActiveSmsNotification"
        [label]="'application.parameters.notification.radio-button' | translate"
        [yesNoTranslations]="{
          yes: 'application.parameters.notification.yes' | translate,
          no: 'application.parameters.notification.no' | translate
        }"
      />
      @if (notificationForm.isActiveSmsNotification().disabled()) {
        <ml-infobubble
          [class]="'info-bubble'"
          [content]="'application.parameters.notification.info-bubble' | translate"
          [iconName]="'information-lamp'"
          [chevron]="chevronPosition.TOP_LEFT"
        ></ml-infobubble>
      }
      <ml-mobile-phone-signal-input
        [label]="'application.parameters.notification.phone-number' | translate"
        [formField]="notificationForm.mobile"
      ></ml-mobile-phone-signal-input>
    </ml-card-container>
  }
}
